import {
    Button,
    Heading,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useState } from "react";
interface ISingleButtonDialog {
    isOpen: boolean;
    title: string;
    message?: string;
    buttonText: string;
    onAction: () => void | Promise<void>;
    onClose: () => void;
    size?: "sm" | "md" | "lg" | "xl" | "full";
}

function SingleButtonDialog({
    title,
    message,
    buttonText,
    onAction,
    onClose,
    isOpen,
    size = "sm",
}: ISingleButtonDialog) {
    const [isAwaitingAction, setIsAwaitingAction] = useState(false);

    const onClickAction = async () => {
        setIsAwaitingAction(true);
        await onAction();
        setIsAwaitingAction(false);
    };

    return (
        <Modal onClose={onClose} isOpen={isOpen} size={size} closeOnOverlayClick={false}>
            <ModalHeader p={ThemeSpaceVariable.Medium}>
                <Heading as="h3">{title}</Heading>
            </ModalHeader>
            <ModalBody px={ThemeSpaceVariable.Medium} pb={ThemeSpaceVariable.Medium}>
                <Text fontSize={ThemeFontSizeVariable.Medium}>{message}</Text>
            </ModalBody>
            <ModalFooter
                pt={ThemeSpaceVariable.Medium}
                px={ThemeSpaceVariable.Medium}
                pb={ThemeSpaceVariable.Medium}
                display="flex"
                justifyContent="flex-end"
            >
                <Button
                    size="xl"
                    variant="primary"
                    onClick={() => void onClickAction()}
                    isLoading={isAwaitingAction}
                >
                    {buttonText}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default SingleButtonDialog;
